module.exports = __webpack_public_path__ + "static/media/sea_logo.0f9b010d.svg";